import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from '@hello-pangea/dnd'
import FileItem from './dragableFileItem'
import { List } from '@material-ui/core'
import { useAnalysisContext } from '../contextProvider'

const DraggableFileList = () => {
  const { files, updateFile } = useAnalysisContext()
  const handleDragEnd = (result: DropResult) => {
    const { destination, source } = result

    if (!destination || destination.index === source.index) {
      return
    }

    const reorderedFiles = Array.from(files)
    const [movedFile] = reorderedFiles.splice(source.index, 1)
    reorderedFiles.splice(destination.index, 0, movedFile)

    reorderedFiles.forEach((file, index) => {
      updateFile(file.id, { order: index })
    })
  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId='fileList'>
        {(provided) => (
          <List
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{ width: '100%' }}
            disablePadding
          >
            {files
              ? files.map((file, index) => (
                  <Draggable key={file.id} draggableId={file.id} index={index}>
                    {(provided1) => (
                      <FileItem
                        file={file}
                        index={index}
                        provided={provided1}
                      />
                    )}
                  </Draggable>
                ))
              : null}
            {provided.placeholder}
          </List>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default DraggableFileList
